import { BoutonDocument } from '../../components/BoutonDocument.jsx';
import { C } from '../../theme/palette';
import { localeDates } from '../../lib/i18n';

/**
 * « 2026-03 » écrit « mars 2026 ».
 *
 * @param {string} mois mois au format `AAAA-MM`
 * @returns {string} le mois en toutes lettres, ou tel quel s'il est illisible
 */
function moisLisible(mois) {
  const m = /^(\d{4})-(\d{2})$/.exec(mois || '');
  if (!m) return mois || '';
  return new Date(+m[1], +m[2] - 1, 1).toLocaleDateString(localeDates(), {
    month: 'long',
    year: 'numeric',
  });
}

/**
 * Fiches de salaire émises pour l'employé connecté.
 *
 * <p>L'écran lui promettait « sa fiche de salaire », mais la paie lui est
 * fermée : il ne voyait qu'une estimation calculée dans la page. Ce sont ici
 * les décomptes que la direction a émis, figés et conservés par le serveur ;
 * chacun s'ouvre tel qu'il a été remis.
 *
 * @param {object} props propriétés
 * @param {Array<{id: number, mois: string}>} props.fiches fiches émises, la plus récente d'abord
 * @returns {JSX.Element} la liste
 */
export function MesFichesDeSalaire({ fiches }) {
  const liste = fiches || [];
  return (
    <div style={{ marginBottom: 14 }}>
      <div
        style={{
          fontSize: 9,
          fontWeight: 800,
          color: C.muted,
          textTransform: 'uppercase',
          letterSpacing: 0.5,
          marginBottom: 6,
        }}
      >
        🧾 Mes fiches de salaire
      </div>
      {liste.length === 0 ? (
        <div
          style={{
            fontSize: 10.5,
            color: C.muted,
            lineHeight: 1.6,
            background: C.navyXL,
            borderRadius: 9,
            padding: '10px 12px',
          }}
        >
          Aucune fiche de salaire émise pour l'instant. Elles apparaissent ici dès que la direction
          les établit.
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          {liste.map((f) => (
            <div
              key={f.id}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: 8,
                border: '1px solid ' + C.border,
                borderRadius: 9,
                padding: '7px 10px',
              }}
            >
              <span style={{ fontSize: 11, fontWeight: 700, color: C.navy }}>
                {moisLisible(f.mois)}
              </span>
              <BoutonDocument
                chemin={`/mon-espace/fiches-paie/${f.id}/document`}
                label="📄 PDF"
                color={C.green}
                sm
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
